<!-- src/components/ezer/EzerThinkingIndicator.vue -->
<template>
  <div class="ezer-thinking">
    <!-- Animated bot avatar -->
    <div class="ezer-thinking__avatar">
      <svg viewBox="0 0 20 20" width="18" height="18" fill="var(--ezer-primary)">
        <path d="M10 1a6 6 0 0 1 6 6v1a6 6 0 0 1-3 5.2V16a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 7 16v-2.8A6 6 0 0 1 4 8V7a6 6 0 0 1 6-6z"/>
      </svg>
      <span class="ezer-thinking__avatar-ring"></span>
    </div>

    <!-- Content area -->
    <div class="ezer-thinking__body">
      <transition name="ezer-msg-swap" mode="out-in">
        <span class="ezer-thinking__text" :key="currentMessage">
          {{ currentMessage }}
        </span>
      </transition>

      <!-- Animated shimmer bar -->
      <div class="ezer-thinking__bar">
        <div class="ezer-thinking__bar-fill"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue'

const MESSAGES = [
  'Thinking it through\u2026',
  'Looking into that for you\u2026',
  'Gathering the details\u2026',
  'Crunching the data\u2026',
  'Almost there\u2026',
  'Putting it all together\u2026',
]

export default {
  name: 'EzerThinkingIndicator',
  setup() {
    const currentIndex = ref(0)
    const currentMessage = ref(MESSAGES[0])
    let timer = null

    onMounted(() => {
      timer = setInterval(() => {
        currentIndex.value = (currentIndex.value + 1) % MESSAGES.length
        currentMessage.value = MESSAGES[currentIndex.value]
      }, 3000)
    })

    onUnmounted(() => {
      if (timer) clearInterval(timer)
    })

    return { currentMessage }
  },
}
</script>
